<div [formGroup]="form" class="w-full">
    <!-- ===================== SS ===================== -->
    <div *ngIf="tipoScambio === 'SS'" class="iv-rows">
        <div class="iv-row">
            <label>Destra</label>
            <app-segmented-select [options]="opzioniCoppie" formControlName="coppiaActDestro" palette="state3"></app-segmented-select>
        </div>
        <div class="iv-row">
            <label>Sinistra</label>
            <app-segmented-select [options]="opzioniCoppie" formControlName="coppiaActSinistro" palette="state3"></app-segmented-select>
        </div>
    </div>

    <!-- ===================== SD ===================== -->
    <div *ngIf="tipoScambio === 'SD'" class="iv-fieldsets">
        <div>
            <div class="iv-subgroup-title">Telaio 1</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Destra</label>
                    <app-segmented-select [options]="opzioniCoppie" formControlName="coppiaAct1Destra" palette="state3"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Sinistra</label>
                    <app-segmented-select [options]="opzioniCoppie" formControlName="coppiaAct1Sinistra" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>
        <div>
            <div class="iv-subgroup-title">Telaio 2</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Destra</label>
                    <app-segmented-select [options]="opzioniCoppie" formControlName="coppiaAct2Destra" palette="state3"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Sinistra</label>
                    <app-segmented-select [options]="opzioniCoppie" formControlName="coppiaAct2Sinistra" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>
    </div>

    <!-- ===================== SI ===================== -->
    <div *ngIf="tipoScambio === 'SI'" class="iv-fieldsets">
        <div *ngFor="let telaio of [1, 2, 3, 4]">
            <div class="iv-subgroup-title">Telaio {{ telaio }}</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Destra</label>
                    <app-segmented-select [options]="opzioniCoppie" [formControlName]="'coppiaAct' + telaio + 'Destra'" palette="state3"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Sinistra</label>
                    <app-segmented-select [options]="opzioniCoppie" [formControlName]="'coppiaAct' + telaio + 'Sinistra'" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>
    </div>
</div>
